module.exports = __webpack_public_path__ + "img/aboute.035632c9.png";